// HANDOFF SEAM. Returns demo data today.
// To wire live data, replace the body with a call to the KPI summary
// endpoint and map KpiSummary -> KpiItem[]. Labels/captions stay here.
// See README.md in this folder.

import { useMemo } from "react";
import { KPI_DEMO_DATA } from "./kpiDemoData";
import type { KpiAudience, KpiItem } from "./KpiStrip";
import type { KpiMetricId, KpiMetricValue } from "./kpiTypes";

const KPI_DISPLAY: Record<KpiMetricId, { label: string; caption?: string }> = {
    served: { label: "Total Participants Served" },
    services: { label: "Total Services Delivered" },
    hours: { label: "Total Hours Delivered", caption: "Sum of all service duration" },
    avgHours: { label: "Avg Hours per Participant" },
    avgSessions: { label: "Avg Sessions per Participant" },
    noServices: { label: "Participants without Services" },
};

const formatValue = ({ id, value }: KpiMetricValue): string | number | null => {
    if (value === null) return null;

    if (id === "hours") {
        return value.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    }

    if (id === "avgHours" || id === "avgSessions") {
        return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    return value;
};

export const useKpiData = (audience: KpiAudience): { items: KpiItem[]; loading: boolean; error: boolean } => {
    const items = useMemo(
        () => KPI_DEMO_DATA[audience].map((metric) => ({
            id: metric.id,
            ...KPI_DISPLAY[metric.id],
            value: formatValue(metric),
        })),
        [audience]
    );

    return { items, loading: false, error: false };
};
